import type { FormConfig } from '@tencent/wb-ext-form';
import { FormItemName, FormItemType } from '@src/framework/workbench/drawer/constants';
import { config } from '@src/framework/workbench/ui/font-family/config';

export const FORM_CONFIGS: FormConfig[] = [
    {
        type: FormItemType.CUSTOM,
        name: FormItemName.FONT_THEME,
        content: '',
        tooltip: config.tipMsg,
        preventFocus: true,
    },
];
